module.exports = "//img1.rrcimg.com/_next/static/src/assets/hf_1RDZU.png";